<div *ngIf="walletPreferences" class="p-grid">
	<div class="p-col-12 p-md-4">
		<div>Organization Name</div>
		<div class="descriptionText">
			The organization name is displayed on the lock screen when your pass is relevant and by apps such as Mail which act as a conduit for passes. The
			value for the organizationName key in the pass specifies the organization name. Choose a name that users recognize and associate with your
			organization or company.
		</div>
		<div>
			<input
				pInputText
				placeholder="Organization Name"
				class="w-100"
				type="text"
				(ngModelChange)="changesToSave = true; changesToSave = true; changesToSaveChange.emit(true)"
				[(ngModel)]="walletPreferences.organizationName"
			/>
		</div>
		<div class="mb-3">Example: <i>My Restaurant</i></div>
		<div>Description Text</div>
		<div class="descriptionText">
			The description lets VoiceOver make your pass accessible to blind and low-vision users. The description should start with a high-level term such as
			“Membership card,” “Weekly coupon,” or “Bus ticket” followed by one or two small pieces of information, such as the coupon’s offer and the store
			where it’s valid. Don’t try to summarize the entire contents of the pass, but include enough detail to let users distinguish between passes of the
			same type.
		</div>
		<div>
			<input
				pInputText
				placeholder="Description Text"
				class="w-100"
				type="text"
				(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
				[(ngModel)]="walletPreferences.descriptionText"
			/>
		</div>
		<div class="mb-3">Example: <i>My Restaurant</i></div>
		<div>"Secondary" text</div>
		<div class="descriptionText">
			Secondary text is displayed below your strip image and is used to describe what the user has. Add ":cardNumber" to add the last four digits of the
			gift card to the text. Example: <i>Gift card (:cardNumber) for my restaurant</i>
		</div>
		<div>
			<input
				pInputText
				placeholder="Secondary Text"
				class="w-100"
				type="text"
				(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
				[(ngModel)]="walletPreferences.secondaryText"
			/>
		</div>
		<div class="mb-3">Example: <i>Gift card (:cardNumber) for my restaurant</i></div>
		<div>Logo text</div>
		<div class="descriptionText">
			At the top of the pass, Apple Watch displays the logo and logo text. It attempts to degrade gracefully if both items do not fit. Specifically, if
			the pass has a logo, it always displays the logo, but it displays the logo text only when the text fits without being truncated. If the pass does
			not have a logo, it always displays the logo text, even if the text is truncated.
		</div>
		<div>
			<input
				pInputText
				placeholder="Logo Text"
				class="w-100"
				type="text"
				(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
				[(ngModel)]="walletPreferences.logoText"
			/>
		</div>
		<div class="mb-3">Example: <i>My Restaurant</i></div>
		<div>Header field text</div>
		<div class="descriptionText">Header field is used for the user to identify how much of a balance they have on their card.</div>
		<div>
			<input
				pInputText
				placeholder="Logo Text"
				class="w-100"
				type="text"
				(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
				[(ngModel)]="walletPreferences.balanceLabel"
			/>
		</div>
		<div class="mb-3">Example: <i>Balance</i></div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="mb-3">
			<div class="p-grid">
				<div class="p-col">
					<div class="p-grid">
						<div class="col-9">
							<div>
								<span class="p-float-label">
									<input
										pInputText
										(change)="changesToSaveChange.emit(true); changesToSave = true"
										class="mx-2 mb-2"
										id="foregroundColor"
										(change)="colorHexToRgb('foreground')"
										[(ngModel)]="walletPreferences.foregroundHex"
									/>
									<label for="headerTextColor">Text Color</label>
								</span>
							</div>
						</div>
						<div class="col-3">
							<p-colorPicker
								[(ngModel)]="walletPreferences.foreground"
								format="rgb"
								(onChange)="colorSelect('foreground'); changesToSave = true; changesToSaveChange.emit(true)"
							></p-colorPicker>
						</div>
					</div>
				</div>
				<div class="p-col">
					<div class="p-grid mt-2">
						<div class="col-9">
							<div>
								<span class="p-float-label">
									<input
										pInputText
										(change)="changesToSaveChange.emit(true); changesToSave = true"
										class="mx-2 mb-2"
										id="backgroundColor"
										(change)="colorHexToRgb('background')"
										[(ngModel)]="walletPreferences.backgroundHex"
									/>
									<label for="headerTextColor">Pass Background</label>
								</span>
							</div>
						</div>
						<div class="col-3" style="text-align: right">
							<p-colorPicker
								[(ngModel)]="walletPreferences.background"
								format="rgb"
								(onChange)="colorSelect('background'); changesToSave = true; changesToSaveChange.emit(true)"
							></p-colorPicker>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mb-3">
			<div class="p-grid">
				<div class="p-col">
					<div>Strip Image</div>
					<div class="descriptionText">The strip image is displayed behind the primary fields and is the primary image the user will see.</div>
				</div>
				<div class="p-col">
					<div>Icon Image</div>
					<div class="descriptionText">
						The icon is displayed when a pass is shown on the lock screen and by apps such as Mail when showing a pass attached to an email. The
						icon should measure 29 x 29 points.
					</div>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">
					<img
						class="w-100 mb-3"
						[src]="
							'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
							venueService.subscriptionVenue.value.key +
							'/wallet/strip.png?' +
							timestamp
						"
						onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
					/>
				</div>
				<div class="p-col">
					<img
						class="w-100 mb-3"
						[src]="
							'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
							venueService.subscriptionVenue.value.key +
							'/wallet/logo.png?' +
							timestamp
						"
						onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
					/>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">
					<div class="mb-3">
						<p-button
							pRipple
							styleClass="p-button-raised w-100"
							(click)="imgCrop.openImageCropper('walletStrip', undefined, this.venueService.subscriptionVenue.value.key)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
								Edit Strip Image
							</ng-template>
						</p-button>
					</div>
				</div>
				<div class="p-col">
					<div class="mb-3">
						<p-button
							pRipple
							styleClass="p-button-raised w-100"
							(click)="imgCrop.openImageCropper('walletLogo', undefined, this.venueService.subscriptionVenue.value.key)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
								<div class="ms-2">Edit Icon Image</div>
							</ng-template>
						</p-button>
					</div>
				</div>
			</div>
		</div>
		<div class="mb-3">
			<div class="p-grid">
				<div class="p-col">
					<div>Icon Image</div>
					<div class="descriptionText">
						The icon is displayed when a pass is shown on the lock screen and by apps such as Mail when showing a pass attached to an email. The
						icon should measure 29 x 29 points.
					</div>
				</div>
				<div class="p-col">
					<div>Thumbnail Image</div>
					<div class="descriptionText">I don't know where this is displayed.</div>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">
					<img
						class="w-100 mb-3"
						[src]="
							'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
							venueService.subscriptionVenue.value.key +
							'/wallet/icon.png?' +
							timestamp
						"
						onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
					/>
				</div>
				<div class="p-col">
					<img
						class="w-100 mb-3"
						[src]="
							'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
							venueService.subscriptionVenue.value.key +
							'/wallet/thumbnail.png?' +
							timestamp
						"
						onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
					/>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">
					<div class="mb-3">
						<p-button
							pRipple
							styleClass="p-button-raised w-100"
							(click)="imgCrop.openImageCropper('walletIcon', undefined, this.venueService.subscriptionVenue.value.key)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
								Edit Icon Image
							</ng-template>
						</p-button>
					</div>
				</div>
				<div class="p-col">
					<div class="mb-3">
						<p-button
							pRipple
							styleClass="p-button-raised w-100"
							(click)="imgCrop.openImageCropper('walletThumbnail', undefined, this.venueService.subscriptionVenue.value.key)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
								Edit Thumbnail Image
							</ng-template>
						</p-button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div>
			<h4>Reference</h4>
		</div>
		<div>
			<a href="https://developer.apple.com/design/human-interface-guidelines/wallet/overview/pass-design/" target="_blank"
				>Apple Human Interface Guidelines: Designing Passes</a
			>
		</div>
		<div>
			<a href="https://developer.apple.com/library/archive/documentation/UserExperience/Conceptual/PassKit_PG/Creating.html" target="_blank">
				<img class="w-100 mb-3" src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/applewallet-storecard.png" />
			</a>
		</div>
	</div>
</div>
